"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlockWrapper = void 0;
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const styled_components_1 = __importDefault(require("styled-components"));
exports.TextBlockWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: 'text.richText',
    '.text-block-title': {
        mb: [2, 4],
        fontSize: [3, '30px'],
    },
    '.text-block-text': {
        fontSize: [2, 4],
    },
}), ({ theme }) => theme.text.textBlockWrap || {});
//# sourceMappingURL=fdr-text-block.styles.js.map